
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.416","height":"21.875","viewBox":"0 0 26.416 21.875"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_370","d":"M26.1 49.181a1.939 1.939 0 00-1.488-.877L4.521 46.8l-.444-2.18a.774.774 0 00-.758-.62H.774a.774.774 0 000 1.548h1.912l2.659 13.063-.6 1.3a1.955 1.955 0 00.655 2.43 2.2 2.2 0 103.723.349H16.6a2.2 2.2 0 103.941 0h.31a.774.774 0 000-1.548H6.512a.406.406 0 01-.368-.576l.5-1.086H21.92a1.955 1.955 0 001.844-1.309l2.542-7.271a1.939 1.939 0 00-.206-1.719zM7.151 64.327a.655.655 0 11.655-.655.655.655 0 01-.655.655zm11.421 0a.655.655 0 11.655-.655.655.655 0 01-.655.655zm6.273-13.942L22.3 57.66a.406.406 0 01-.383.272H6.786l-1.944-9.553 19.65 1.468a.406.406 0 01.353.538z","transform":"translate(0 -44)","fill":"#fff"}})])
          )
        }
      }
    